import { useQuery } from "react-query";
import { http } from "./http";

export function useAvailableServiceAccounts(serviceName: string, ops: any) {
  const queryKey = `/api/connections/${serviceName}/accounts`;

  return useQuery<any[]>({
    queryKey: [queryKey],
    queryFn: () => http(queryKey),
    ...ops
  });
}